var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.items.length > 0)?_c('ul',{staticClass:"wards__list"},_vm._l((_vm.items),function(item){return _c('ward',{key:item.id,attrs:{"item":item}})}),1):_c('div',[_c('h5',[_vm._v("Вы пока не пригласили пользователей.")])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-016bfa60","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./themes/oprava/src/js/components/commerce/curator-users.vue
// module id = 98
// module chunks = 0